import { render, staticRenderFns } from "./payout.vue?vue&type=template&id=70df93b2&"
import script from "./payout.vue?vue&type=script&lang=js&"
export * from "./payout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports